import {
  AuthDispatch,
  AuthDispatchContext,
} from "../contexts/AuthDispatchContext";
import { AuthState, AuthStateContext } from "../contexts/AuthStateContext";
import { TDao } from "../../../../_types/TDao";
import { useHydrateAtoms } from "jotai/utils";
import { daoAtom } from "../../../../_model/dao/daoAtom";
import { PropsWithChildren, useEffect } from "react";
import { daoSubdomainAtom } from "../../../../_model/dao/daoSubdomainAtom";
import { extractParams } from "../../../../_utils/converter/mobile/extractParams";
import { useDaoSubdomainStore } from "../../../../_store/dao/useDaoSubdomainStore";
import { getDaos } from "../../../../_api/dao/getDaos";
import { ECode } from "../../../../_enums/ECode";
import { useDaoStore } from "../../../../_store/dao/useDaoStore";
import { useLocation } from "react-router-dom";

export function MainModule({
  children,
  ...params
}: PropsWithChildren<{
  dao: TDao | null;
  subdomain: string | null;
  authState: AuthState;
  authDispatch: AuthDispatch;
}>) {
  useHydrateAtoms([
    [daoAtom, params.dao],
    [daoSubdomainAtom, params.subdomain],
  ]);
  const { daoSubdomain, setDaoSubdomain } = useDaoSubdomainStore();
  const { setDao } = useDaoStore();
  const { pathname } = useLocation();

  useEffect(() => {
    const { subdomain } = extractParams(pathname);
    if (subdomain == null || subdomain === daoSubdomain) {
      return;
    }
    getDaos({ subdomain }, { daoSubdomain: subdomain }).then(
      ({ code, data }) => {
        if (code === ECode.Success) {
          setDao(data[0] ?? null);
          setDaoSubdomain(data[0]?.subdomain ?? null);
        }
      },
    );
  }, [daoSubdomain, pathname, setDao, setDaoSubdomain]);

  return (
    <AuthDispatchContext.Provider value={params.authDispatch}>
      <AuthStateContext.Provider value={params.authState}>
        {children}
      </AuthStateContext.Provider>
    </AuthDispatchContext.Provider>
  );
}
